var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgVector = function SvgVector(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.78 5.8c-.338 0-.66-.048-.902-.145L.85 3.818c-.419-.145-.467-.37-.467-.5 0-.113.064-.338.467-.5L5.862.966C6.104.87 6.426.82 6.765.82c.338 0 .66.049.902.145l5.028 1.854c.42.145.468.37.468.5 0 .112-.065.338-.468.499L7.683 5.67c-.241.08-.564.13-.902.13zm-1.079 8.364a.918.918 0 01-.354-.064L.963 12.424c-.516-.194-.902-.79-.902-1.386V5.446c0-.5.274-.822.693-.822.112 0 .225.016.338.064L5.54 6.364c.532.194.967.806.967 1.386v5.592c-.016.484-.355.822-.806.822zm2.256-.096h.017c-.42 0-.677-.242-.677-.726V7.75c0-.596.37-1.192.886-1.386l4.384-1.676a.946.946 0 01.37-.064c.452 0 .79.338.79.822v5.592c0 .58-.451 1.192-.983 1.386l-4.448 1.628c-.097.048-.226.016-.339.016z",
    fill: "#F75C2F"
  })));
};

export default SvgVector;